module.exports = __webpack_public_path__ + "img/l-catterton.fff00181.jpg";